<template>
  <section class="header">
    <!-- Market Indicators Bar -->
    <!--<div class="market-indicators">
      <div class="market-section">
        <span class="market-label">Brasil</span>
        <div class="indicators-list">
          <template v-if="brasilQuotes.length">
            <span v-for="(item, i) in brasilQuotes" :key="`br-${i}`" class="indicator-item">
              {{ item.name }}<span class="value" :class="item.positive === true ? 'positive' : item.positive === false ? 'negative' : ''">{{ item.last }} {{ item.varPct }}</span>
            </span>
          </template>
          <template v-else>
            <span class="indicator-item">IBOV<span class="value positive">128.500 +0.85%</span></span>
            <span class="indicator-item">DOL<span class="value negative">5.15 -0.30%</span></span>
            <span class="indicator-item">PETR<span class="value positive">436.50 +1.20%</span></span>
            <span class="indicator-item">VALE<span class="value negative">368.90 -0.50%</span></span>
            <span class="indicator-item">ITUB<span class="value positive">432.40 +0.45%</span></span>
          </template>
        </div>
      </div>
      <div class="market-section">
        <span class="market-label">EUA</span>
        <div class="indicators-list">
          <template v-if="euaQuotes.length">
            <span v-for="(item, i) in euaQuotes" :key="`us-${i}`" class="indicator-item">
              {{ item.name }}<span class="value" :class="item.positive === true ? 'positive' : item.positive === false ? 'negative' : ''">{{ item.last }} {{ item.varPct }}</span>
            </span>
          </template>
          <template v-else>
            <span class="indicator-item">S&P 500<span class="value positive">5.200 +0.60%</span></span>
            <span class="indicator-item">NASDAQ<span class="value positive">16.400 +0.90%</span></span>
            <span class="indicator-item">DOW J<span class="value negative">39.100 -0.10%</span></span>
            <span class="indicator-item">AAPL<span class="value positive">175.50 +1.10%</span></span>
            <span class="indicator-item">NVDA<span class="value positive">950.00 +2.50%</span></span>
          </template>
        </div>
      </div>
    </div>-->
    <!--Main Header-->
    <div class="header-container">
      <div @click="home" class="header-logo">
        <Logo />
      </div>
      <nav class="header-nav">
        <a @click.prevent="scrollToSection('ferramentas')" href="#ferramentas" class="nav-link">Ferramentas de Precisão</a>
        <a @click.prevent="scrollToSection('resultados')" href="#resultados" class="nav-link">Resultados</a>
        <!--<a @click.prevent="scrollToSection('hero')" href="#natal" class="nav-link">NATAL SWISS</a>-->
        <a @click.prevent="scrollToSection('planos')" href="#planos" class="nav-link">Planos</a>
        <!--<a @click.prevent="scrollToSection('feedbacks')" href="#parcerias" class="nav-link">Parcerias</a>-->
        <a @click.prevent="scrollToSection('feedbacks')" href="#feedbacks" class="nav-link">Feedbacks</a>
      </nav>
      <div @click="openUserLogin" class="club-login-btn">
        <span>Entrar</span>
        <i class="fas fa-user"></i>
      </div>
    </div>
    <Login v-if="showLogin && !name" />
    <Slide right :closeOnNavigation="true" v-if="name">
      <a @click="callProfile">
        <span><i class="fas fa-user" style="margin-right: 10px;"></i>Perfil</span>
      </a>
      <a @click="callPlan">
        <span><i class="fas fa-money-check-alt" style="margin-right: 10px;"></i>Assinatura</span>
      </a>
      <a @click="callVideos">
        <span><i class="fas fa-play-circle" style="margin-right: 10px;"></i>Videos</span>
      </a>
      <a @click="signOut">
        <span><i class="fas fa-sign-out-alt" style="margin-right: 10px;"></i>Sair</span>
      </a>
    </Slide>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Login from './Login.vue'
import Logo from './Logo.vue'
import { removeToken } from '../../util'
// import { getData, setData } from '../../util'
import { get } from '../api/customer'
import { getMarketQuotes } from '../api/market'
import logger from '../../logger'
import { Slide } from 'vue-burger-menu'

export default {
  name: 'Header',
  components: { Slide, Login, Logo },
  data () {
    return {
      openSelectCity: false,
      search: null,
      cities: [],
      name: null,
      brasilQuotes: [],
      euaQuotes: []
    }
  },
  computed: {
    ...mapState(['showLogin', 'reload', 'city', 'user'])
  },
  watch: {
    async user (newValue, oldValue) {
      if (newValue) {
        try {
          const customer = await get()
          this.name = customer.name.split(' ')[0]
          this.$message.success('Seja bem-vindo ' + this.name + '!', { duration: 3000 })
        } catch (error) {
          logger.error(error, this)
        }
      } else {
        this.name = null
      }
    }
  },
  async mounted () {
    if (this.user) {
      try {
        const customer = await get()
        this.name = customer.name.split(' ')[0]
      } catch (error) {
        logger.error(error, this)
      }
    }
    try {
      const { brasil, eua } = await getMarketQuotes()
      if (brasil && brasil.length) this.brasilQuotes = brasil
      if (eua && eua.length) this.euaQuotes = eua
    } catch (e) {
      // mantém dados estáticos em brasilQuotes/euaQuotes vazios
    }
  },
  methods: {
    home () {
      this.$store.commit('search', null)
      this.openSelectCity = false
      this.search = null
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          setTimeout(() => this.scrollToSection('hero'), 100)
        })
      } else {
        this.scrollToSection('hero')
      }
    },
    scrollToSection (sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else if (sectionId === 'ferramentas' || sectionId === 'resultados' || sectionId === 'planos' || sectionId === 'feedbacks') {
        // Se não encontrou, tenta scrollar após um pequeno delay
        setTimeout(() => {
          const el = document.getElementById(sectionId)
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 300)
      }
    },
    openUserLogin () {
      if (this.user) {
        this.$router.push('/usuario')
      } else {
        this.$store.commit('showLogin', true)
      }
      this.openSelectCity = false
    },
    callProfile () {
      this.$router.push('/usuario')
    },
    callPlan () {
      this.$router.push('/assinatura')
    },
    callVideos () {
      this.$router.push('/videos')
    },
    signOut () {
      setTimeout(() => {
        removeToken()
        document.body.style.backgroundColor = '#1e1e1e'
        this.$store.commit('user', null)
        this.$router.push('/')
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../_asset/scss/_variables";

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #000;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
}

.market-indicators {
  display: none;
  background: #0a0a0a;
  border-bottom: 1px solid #222;
  padding: 8px 0;
  overflow-x: auto;

  .market-section {
    display: flex;
    align-items: center;
    padding: 0 20px;
    white-space: nowrap;

    .market-label {
      font-weight: 600;
      color: #fff;
      margin-right: 15px;
      font-size: 12px;
    }

    .indicators-list {
      display: flex;
      gap: 20px;
    }

    .indicator-item {
      color: #ccc;
      font-size: 11px;
      white-space: nowrap;

      .value {
        margin-left: 5px;
        font-weight: 600;

        &.positive {
          color: #00ff88;
        }

        &.negative {
          color: #ff4444;
        }
      }
    }
  }
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  min-height: 70px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.header-nav {
  display: none;
  flex: 1;
  justify-content: center;
  gap: 30px;
  margin: 0 40px;

  .nav-link {
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: color 0.3s;
    white-space: nowrap;

    &:hover {
      color: #00ff88;
    }
  }
}

.club-login-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(to bottom right, #5134f5, #8d6ef4);
  color: #000;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 255, 136, 0.3);
  }

  i {
    font-size: 16px;
  }
}

.user-container {
  display: none;
}

// Desktop
@media screen and (min-width: 1024px) {
  .market-indicators {
    display: flex;
    justify-content: center;
    gap: 40px;
  }

  .header-nav {
    display: flex;
  }
}

// Tablet
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .header-nav {
    display: flex;
    gap: 15px;
    margin: 0 20px;

    .nav-link {
      font-size: 12px;
    }
  }
}

// Mobile Menu
@media screen and (max-width: 767px) {
  .header-container {
    padding: 0 15px;
  }

  .club-login-btn {
    padding: 8px 15px;
    font-size: 12px;

    span {
      display: none;
    }
  }
}

// Print
@media print {
  .header {
    display: none;
  }
}
</style>

<style>
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 25px !important;
  cursor: pointer;
}
.bm-burger-bars {
  background-color: #cbccd0 !important;
}
.bm-item-list > a:hover {
  background-color: #8d8e90 !important;
  cursor: pointer;
}
</style>
